import logo from "./logo-garuda-big.png";
import { useRef, useState, useEffect, forwardRef } from "react";
import MapContainer from "./components/MapContainer";
import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  Grid,
  IconButton,
  Tab,
  Tabs,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Checkbox,
} from "@mui/material";
import {
  AddCircle,
  Close,
  ExpandLess,
  ExpandMore,
  Info,
  LayersRounded,
  NavigateBefore,
  NavigateNext,
  Print as PrintIcon,
  UnfoldMore,
  MoreVert,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import MediaCard from "./components/MediaCard";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function App() {
  const [center, setCenter] = useState([118, -1.93]);
  const [zoom, setZoom] = useState(5.8);
  const [basemap, setBasemap] = useState("rbi");
  const [collapsedMenu, setCollapsedMenu] = useState(true);
  const [collapsedLegenda, setCollapsedLegenda] = useState(true);
  const [collapsedData, setCollapsedData] = useState(true);
  const [collapsedInfo, setCollapsedInfo] = useState(true);
  const [value, setValue] = useState(2);
  const [source, setSource] = useState("PK 2022");
  const [tag, setTag] = useState("Provinsi");
  const [wilayah, setWilayah] = useState("Provinsi");
  const [label, setLabel] = useState("Belum ada indikator yang dipilih");
  const [mapLayer, setMapLayer] = useState([]);
  const [identifierDelete, setIdentifierDelete] = useState("");
  //const [checked, setChecked] = useState([0]);
  //const [anchorEl, setAnchorEl] = useState(null);

  const iconMenu = collapsedMenu ? (
    <ExpandMore fontSize="small" sx={{ color: "white" }} />
  ) : (
    <ExpandLess fontSize="small" sx={{ color: "white" }} />
  );
  const iconLegenda = collapsedLegenda ? (
    <NavigateNext fontSize="small" sx={{ color: "white" }} />
  ) : (
    <NavigateBefore fontSize="small" sx={{ color: "white" }} />
  );
  const iconData = collapsedData ? (
    <UnfoldMore sx={{ color: "#000000de" }} />
  ) : (
    <UnfoldMore sx={{ color: "#000000ef" }} />
  );

  const list = [
    "Prevalensi Stunting",
    "Persentase keluarga sasaran  yang memiliki anak baduta (0-23 bulan)",
    "Persentase keluarga sasaran  yang memiliki anak balita (24-59 bulan)",
    "Persentase Keluarga berisiko stunting yang tidak mempunyai sumber air minum utama yang layak",
    "Persentase keluarga berisiko stunting yang tidak mempunyai jamban yang layak",
    "Persentase Keluarga Sasaran yang berstatus PUS",
    "Persentase Keluarga Sasaran yang berstatus PUS Hamil",
    "Persentase pasangan usia subur dengan umur istri kurang dari 20 tahun (terlalu muda)",
    "Persentase pasangan usia subur dengan umur istri 35 - 40 tahun (terlalu tua)",
    "Persentase pasangan usia subur dengan jarak antara satu anak dan anak lainnya kurang dari 2 tahun (terlalu dekat)",
    "Persentase pasangan usia subur dengan jumlah anak lebih besar sama dengan 3 tahun (terlalu banyak)",
    "Persentase Keluarga Beresiko Stunting",
    "Persentase Keluarga Beresiko Stunting Miskin Ekstrem dan Miskin",
    "Persentase Keluarga Beresiko Stunting Rentan Miskin",
    "Persentase Keluarga Beresiko Stunting Tidak Miskin",
  ];

  const indikator_pk2021 = [
    {
      id: 1,
      label: list[0],
      layer: "qpk21_1",
      column: "prev_stunt",
      provinsi: true,
      kabupaten: true,
      kecamatan: false,
      desa: false,
      bnba: false,
    },
    {
      id: 2,
      label: list[1],
      layer: "qpk21_2",
      column: "bln_0_23n",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 3,
      label: list[2],
      layer: "qpk21_3",
      column: "balitan",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 4,
      label: list[3],
      layer: "qpk21_4",
      column: "riskn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 5,
      label: list[4],
      layer: "qpk21_5",
      column: "pushmln",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 6,
      label: list[5],
      layer: "qpk21_6",
      column: "jmbnlykbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 7,
      label: list[6],
      layer: "qpk21_7",
      column: "smbairbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 8,
      label: list[7],
      layer: "qpk21_8",
      column: "tll_mudan",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 9,
      label: list[8],
      layer: "qpk21_9",
      column: "tll_tuan",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 10,
      label: list[9],
      layer: "qpk21_10",
      column: "tll_dktn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 11,
      label: list[10],
      layer: "qpk21_11",
      column: "tll_bnykn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 12,
      label: list[11],
      layer: "qpk21_12",
      column: "kbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 13,
      label: list[12],
      layer: "qpk21_13",
      column: "kbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 14,
      label: list[13],
      layer: "qpk21_14",
      column: "kbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 15,
      label: list[14],
      layer: "qpk21_15",
      column: "kbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
  ];
  const indikator_verval = [
    {
      id: 1,
      label: list[1],
      layer: "qverval_2",
      column: "bln_0_23n",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 2,
      label: list[2],
      layer: "qverval_3",
      column: "balitan",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 3,
      label: list[3],
      layer: "qverval_4",
      column: "riskn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 4,
      label: list[4],
      layer: "qverval_5",
      column: "pushmln",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 5,
      label: list[5],
      layer: "qverval_6",
      column: "jmbnlykbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 6,
      label: list[6],
      layer: "qverval_7",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 7,
      label: list[7],
      layer: "qverval_8",
      column: "tll_mudan",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 8,
      label: list[8],
      layer: "qverval_9",
      column: "tll_tuan",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 9,
      label: list[9],
      layer: "qverval_10",
      column: "tll_dktn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 10,
      label: list[10],
      layer: "qverval_11",
      column: "tll_bnykn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 11,
      label: list[11],
      layer: "qverval_12",
      column: "kbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 12,
      label: list[12],
      layer: "qverval_13",
      column: "risk0n",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 13,
      label: list[13],
      layer: "qverval_14",
      column: "risk0n",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 14,
      label: list[14],
      layer: "qverval_15",
      column: "risk0n",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
  ];
  const indikator_pk2022 = [
    {
      id: 1,
      label: list[0],
      layer: "qpk22_1",
      column: "prev_stunt",
      provinsi: true,
      kabupaten: true,
      kecamatan: false,
      desa: false,
      bnba: false,
    },
    {
      id: 2,
      label: list[1],
      layer: "qpk22_2",
      column: "bln_0_23n",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 3,
      label: list[2],
      layer: "qpk22_3",
      column: "balitan",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 4,
      label: list[3],
      layer: "qpk22_4",
      column: "riskn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 5,
      label: list[4],
      layer: "qpk22_5",
      column: "pushmln",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 6,
      label: list[5],
      layer: "qpk22_6",
      column: "jmbnlykbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 7,
      label: list[6],
      layer: "qpk22_7",
      column: "smbairbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 8,
      label: list[7],
      layer: "qpk22_8",
      column: "tll_mudan",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 9,
      label: list[8],
      layer: "qpk22_9",
      column: "tll_tuan",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 10,
      label: list[9],
      layer: "qpk22_10",
      column: "tll_dktn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 11,
      label: list[10],
      layer: "qpk22_11",
      column: "tll_bnykn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 12,
      label: list[11],
      layer: "qpk22_12",
      column: "kbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 13,
      label: list[12],
      layer: "qpk22_13",
      column: "kbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 14,
      label: list[13],
      layer: "qpk22_14",
      column: "kbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
    {
      id: 15,
      label: list[14],
      layer: "qpk22_15",
      column: "kbn",
      provinsi: true,
      kabupaten: true,
      kecamatan: true,
      desa: true,
      bnba: true,
    },
  ];
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleTag = (tag) => {
    setTag(tag);
  };

  function deleteDataset(id) {
    //setDataset(oldArray => [...oldArray, newElement]);
    //console.log(dataset);

    const layers = mapLayer.slice();
    console.log(id);

    setMapLayer(mapLayer.filter((item) => item.id !== id));
    setIdentifierDelete(id);
  }

  function handleVisible(id) {
    //setIdentifierVisible(id);
    const data = mapLayer.slice();
    //console.log(data[0]);
    var index = mapLayer.findIndex((x) => x.id === id);
    //console.log(index);
    data[index].visible = !data[index].visible;
    setMapLayer(data);
  }
  /*
  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    //setRow(row);
    //setId(row.id)
    //setUrlWMS(row.url)
    //console.log(row)
  };
  */

  function closeMenu() {
    var legendContainer = document.getElementById("information");
    if (collapsedMenu) {
      legendContainer.style.height = "70vh";
      setCollapsedMenu(false);
    } else {
      legendContainer.style.height = "70px";
      setCollapsedMenu(true);
    }
  }

  function closeLegenda() {
    var leftSide = document.getElementById("leftSide");
    var leftContent = document.getElementById("leftContent");
    var legend = document.getElementById("legenda");

    if (collapsedLegenda) {
      leftSide.style.width = "250px";
      leftContent.style.display = "flex";
      leftContent.style.width = "250px";
      legend.style.left = "260px";
      setCollapsedLegenda(false);
    } else {
      leftSide.style.width = "0px";
      leftContent.style.display = "none";
      leftContent.style.width = "0px";
      legend.style.left = "0px";
      setCollapsedLegenda(true);
    }
  }

  function openData() {
    var full = document.getElementById("full");
    var dialog = document.getElementById("dialog");
    var full_info = document.getElementById("full-info");
    var dialog_info = document.getElementById("dialog-info");
    full_info.style.display = "none";
    dialog_info.style.display = "none";
    setCollapsedInfo(true);

    if (collapsedData) {
      full.style.display = "block";
      dialog.style.display = "block";
      setCollapsedData(false);
    } else {
      full.style.display = "none";
      dialog.style.display = "none";
      setCollapsedData(true);
    }
  }

  function openInfo() {
    var full = document.getElementById("full");
    var dialog = document.getElementById("dialog");
    var full_info = document.getElementById("full-info");
    var dialog_info = document.getElementById("dialog-info");
    full.style.display = "none";
    dialog.style.display = "none";
    setCollapsedData(true);

    if (collapsedInfo) {
      full_info.style.display = "block";
      dialog_info.style.display = "block";
      setCollapsedInfo(false);
    } else {
      full_info.style.display = "none";
      dialog_info.style.display = "none";
      setCollapsedInfo(true);
    }
  }
  function getListLayers() {
    if (mapLayer !== "undefined") {
      if (mapLayer.length > 0) {
        var rev = [...mapLayer].reverse();
        //console.log(rev);
        return rev.map((row, index) => {
          console.log(row);
          //console.log(row.id.includes('uploader'))
          //onChange={(e) => props.setLayerVisible(row.id)}

          const labelId = `checkbox-list-label-${index}`;
          var source = "";
          if (row.value == 0) {
            source = "PK 2021";
          } else if (row.value == 1) {
            source = "Verval 2022";
          } else if (row.value == 2) {
            source = "PK 2022";
          }
          return (
            <ListItem
              key={index}
              role={undefined}
              dense
              button
              style={{ padding: "0px" }}
            >
              <ListItemIcon style={{ minWidth: "16px" }}>
                <Checkbox
                  edge="start"
                  checked={row.visible}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                  onClick={() => handleVisible(row.id)}
                />
              </ListItemIcon>
              <ListItemText
                id={labelId}
                primary={`${row.title}`}
                secondary={`${row.tag + ", " + source}`}
                style={{ fontSize: "10px", maxWidth: "185px" }}
              />
              <ListItemSecondaryAction style={{ right: "0px" }}>
                <IconButton
                  edge="end"
                  aria-label="comments"
                  onClick={() => deleteDataset(row.id)}
                >
                  <DeleteIcon />
                </IconButton>
                {/*
                <IconButton edge="end" aria-label="comments" onClick={(e) => handleClick(e, row)} >
                  <MoreVert />
                </IconButton>
                */}
              </ListItemSecondaryAction>
            </ListItem>
          );
        });
      } else {
        return (
          <h5 style={{ margin: "0px", color: "#888" }}>
            Belum ada layer yang ditambahkan. Pilih salah satu data indikator
            terlebih dahulu.
          </h5>
        );
      }
    }
  }

  function generate_indikator() {
    var tampung;

    if (value == 0) {
      if (indikator_pk2021 !== "undefined") {
        if (indikator_pk2021.length > 0) {
          if (tag === "Provinsi")
            tampung = indikator_pk2021.filter((item) => item.provinsi === true);
          else if (tag === "Kabupaten")
            tampung = indikator_pk2021.filter(
              (item) => item.kabupaten === true
            );
          else if (tag === "Kecamatan")
            tampung = indikator_pk2021.filter(
              (item) => item.kecamatan === true
            );
          else if (tag === "Desa")
            tampung = indikator_pk2021.filter((item) => item.desa === true);
          else tampung = indikator_pk2021;
        }
      } else {
        return (
          <h5 style={{ margin: "0px", color: "#888" }}>
            Belum ada data daftar indikator PK 2021.
          </h5>
        );
      }
    } else if (value == 1) {
      if (indikator_verval !== "undefined") {
        if (indikator_verval.length > 0) {
          if (tag === "Provinsi")
            tampung = indikator_verval.filter((item) => item.provinsi === true);
          else if (tag === "Kabupaten")
            tampung = indikator_verval.filter(
              (item) => item.kabupaten === true
            );
          else if (tag === "Kecamatan")
            tampung = indikator_verval.filter(
              (item) => item.kecamatan === true
            );
          else if (tag === "Desa")
            tampung = indikator_verval.filter((item) => item.desa === true);
          else tampung = indikator_verval;
        }
      } else {
        return (
          <h5 style={{ margin: "0px", color: "#888" }}>
            Belum ada data daftar indikator Verval 2022.
          </h5>
        );
      }
    } else if (value == 2) {
      if (indikator_pk2022 !== "undefined") {
        if (indikator_pk2022.length > 0) {
          if (tag === "Provinsi")
            tampung = indikator_pk2022.filter((item) => item.provinsi === true);
          else if (tag === "Kabupaten")
            tampung = indikator_pk2022.filter(
              (item) => item.kabupaten === true
            );
          else if (tag === "Kecamatan")
            tampung = indikator_pk2022.filter(
              (item) => item.kecamatan === true
            );
          else if (tag === "Desa")
            tampung = indikator_pk2022.filter((item) => item.desa === true);
          else tampung = indikator_pk2022;
        }
      } else {
        return (
          <h5 style={{ margin: "0px", color: "#888" }}>
            Belum ada data daftar indikator PK 2022.
          </h5>
        );
      }
    }
    return tampung.map((row, index) => {
      //console.log(row);
      return (
        <MediaCard
          key={row.layer}
          title={row.label}
          layer={tag.toLowerCase() + "_" + row.layer}
          setMapLayer={(e) => setMapLayer(e)}
          openData={() => openData()}
          setLabel={(e) => setLabel(e)}
          tag={tag}
          setWilayah={(e) => setWilayah(e)}
          value={value}
          setSource={(e) => setSource(e)}
          setCollapsedLegenda={(e) => setCollapsedLegenda(e)}
        />
      );
    });
  }

  return (
    <div>
      <div style={{ position: "fixed", width: "100%", zIndex: 104 }}>
        <div
          id="information"
          style={{
            height: "70px",
            background: "#ececec",
            transition: "all 0.8s",
          }}
        >
          <div
            style={{
              display: "flex",
              height: "70px",
              justifyContent: "space-between",
              backgroundColor: "rgba(255,255,255, 0.85)",
              padding: "0 2%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <img src={logo} alt="logo garuda" width="45px" height="51px" />
              <h2 style={{ paddingLeft: "15px" }}>
                Dashboard Stunting dan Keluarga Beresiko Stunting
              </h2>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src="big.png" height="75px" />
              <img src="logo_bkkbn.png" height="50px" />
            </div>
          </div>
          <div
            style={{ display: "none", background: "#f00", height: "500px" }}
          ></div>
        </div>
        <div
          style={{ background: "#2a63b5", height: "6px", cursor: "pointer" }}
        ></div>
        <div
          style={{
            position: "absolute",
            right: "50px",
            cursor: "pointer",
            background: "#2a63b5",
            width: "30px",
            height: "25px",
            color: "#fff",
            borderBottomLeftRadius: "5px",
            borderBottomRightRadius: "5px",
            marginTop: "-5px",
          }}
        >
          <IconButton id="icon" size="small" onClick={() => closeMenu()}>
            {iconMenu}
          </IconButton>
        </div>
      </div>
      <div
        id="leftSide"
        style={{
          position: "absolute",
          width: "0px",
          flexDirection: "row",
          top: "25vh",
          height: "50vh",
          zIndex: 99,
          transition: "all 0.8s",
          borderTopRightRadius: "20px",
          borderBottomRightRadius: "20px",
        }}
      >
        <div
          id="leftContent"
          style={{
            background: "#fff",
            width: "0px",
            display: "none",
            height: "48vh",
            borderTop: "solid 6px #2a63b5",
            borderRight: "solid 6px #2a63b5",
            borderBottom: "solid 6px #2a63b5",
            borderTopRightRadius: "20px",
            borderBottomRightRadius: "20px",
            padding: "10px",
            transition: "all 0.8s",
          }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", width: "250px" }}
          >
            <div
              style={{
                padding: "10px",
                maxHeight: "48vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <p style={{ margin: "0px", userSelect: "none" }}>
                <b>Daftar Layer [{mapLayer.length}] </b>
              </p>
              <List>{getListLayers()}</List>
            </div>
          </div>
        </div>
      </div>
      <div
        id="legenda"
        style={{
          position: "absolute",
          background: "#2a63b5",
          width: "30px",
          height: "120px",
          top: "calc(50vh - 55px)",
          zIndex: 103,
          cursor: "pointer",
          transition: "all 0.2s",
        }}
        onClick={() => closeLegenda()}
      >
        <IconButton
          id="icon"
          size="small"
          onClick={() => closeLegenda()}
          style={{ marginTop: "10px" }}
        >
          {iconLegenda}
        </IconButton>
        <div
          style={{
            WebkitTransform: "rotate(90deg)",
            letterSpacing: "2px",
            marginTop: "10px",
          }}
        >
          <span style={{ color: "#fff" }}>LAYER</span>
        </div>
      </div>

      <div
        id="data"
        style={{
          position: "absolute",
          height: "40px",
          width: "75vw",
          top: "81px",
          zIndex: 99,
          cursor: "pointer",
        }}
      >
        <div
          style={{
            background: "#fff",
            marginLeft: "25vw",
            width: "52vw",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {/*
            <div style={{background:"#00a1cd", width:"40px", height:"40px", display:"flex", justifyContent:"center", alignItems:"center"}} onClick={() => openInfo()}>
            <Info size="36" htmlColor='#fff' />
            </div>
            */}
          <div
            style={{
              background: "#271d6c",
              width: "40px",
              height: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() => openData()}
          >
            <AddCircle size="36" htmlColor="#fff" />
          </div>
          <div
            style={{ flex: "2", paddingLeft: "15px" }}
            onClick={() => openData()}
          >
            {label}
          </div>
          <Chip
            label={wilayah}
            style={{ marginRight: "10px" }}
            onClick={() => openData()}
          />
          <Chip
            label={source}
            style={{ marginRight: "10px" }}
            onClick={() => openData()}
          />

          <IconButton
            id="icon"
            size="small"
            onClick={() => openData()}
            style={{ marginRight: "10px" }}
          >
            {iconData}
          </IconButton>
        </div>
      </div>

      <div
        id="full"
        style={{
          display: "none",
          background: "transparent",
          position: "absolute",
          height: "calc(100vh - 126px)",
          top: "126px",
          width: "100vw",
          zIndex: 101,
          cursor: "pointer",
        }}
        onClick={() => openData()}
      ></div>
      <div
        id="dialog"
        style={{
          position: "absolute",
          display: "none",
          background: "#fff",
          marginLeft: "20vw",
          marginTop: "126px",
          width: "60vw",
          height: "70vh",
          zIndex: 102,
          padding: "10px 10px 20px 10px",
        }}
      >
        <div style={{ float: "right" }}>
          <IconButton size="small" onClick={() => openData()}>
            <Close fontSize="small" />
          </IconButton>
        </div>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="PK 2021" {...a11yProps(0)} />
            <Tab label="Verval 2022" {...a11yProps(1)} />
            <Tab label="PK 2022" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <div>
            Sumber Data: <b>PK 2021</b> | Level Wilayah:{" "}
            <Chip
              label="Provinsi"
              variant={tag === "Provinsi" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Provinsi")}
            />
            <Chip
              label="Kabupaten"
              variant={tag === "Kabupaten" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Kabupaten")}
            />
            <Chip
              label="Kecamatan"
              variant={tag === "Kecamatan" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Kecamatan")}
            />
            <Chip
              label="Desa"
              variant={tag === "Desa" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Desa")}
            />
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              maxHeight: "52vh",
              overflowY: "auto",
            }}
          >
            {generate_indikator()}
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <div>
            Sumber Data: <b>Verval 2022</b> | Level Wilayah:{" "}
            <Chip
              label="Provinsi"
              variant={tag === "Provinsi" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Provinsi")}
            />
            <Chip
              label="Kabupaten"
              variant={tag === "Kabupaten" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Kabupaten")}
            />
            <Chip
              label="Kecamatan"
              variant={tag === "Kecamatan" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Kecamatan")}
            />
            <Chip
              label="Desa"
              variant={tag === "Desa" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Desa")}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              maxHeight: "52vh",
              overflowY: "auto",
            }}
          >
            {generate_indikator()}
          </div>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <div>
            Sumber Data: <b>PK 2022</b> | Level Wilayah:{" "}
            <Chip
              label="Provinsi"
              variant={tag === "Provinsi" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Provinsi")}
            />
            <Chip
              label="Kabupaten"
              variant={tag === "Kabupaten" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Kabupaten")}
            />
            <Chip
              label="Kecamatan"
              variant={tag === "Kecamatan" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Kecamatan")}
            />
            <Chip
              label="Desa"
              variant={tag === "Desa" ? "default" : "outlined"}
              style={{ marginRight: 10 }}
              onClick={() => handleTag("Desa")}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              maxHeight: "52vh",
              overflowY: "auto",
            }}
          >
            {generate_indikator()}
          </div>
        </TabPanel>
      </div>

      <div
        id="full-info"
        style={{
          display: "none",
          background: "transparent",
          position: "absolute",
          height: "calc(100vh - 126px)",
          top: "126px",
          width: "100vw",
          zIndex: 101,
          cursor: "pointer",
        }}
        onClick={() => openInfo()}
      ></div>
      <div
        id="dialog-info"
        style={{
          position: "absolute",
          display: "none",
          background: "#ffffef",
          marginLeft: "20vw",
          marginTop: "126px",
          width: "60vw",
          height: "70vh",
          zIndex: 102,
          padding: "10px 20px 20px 20px",
        }}
      >
        <div style={{ float: "right" }}>
          <IconButton size="small" onClick={() => openInfo()}>
            <Close fontSize="small" />
          </IconButton>
        </div>
        <div>Info</div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <MapContainer
          id="mapContainer"
          center={center}
          zoom={zoom}
          basemap={basemap}
          setBasemap={setBasemap}
          mapLayer={mapLayer}
          identifierDelete={identifierDelete}
          setIdentifierDelete={setIdentifierDelete}
          list={list}
        />
      </div>
    </div>
  );
}

export default App;
